function required(name, value) {
  if (value) return value
  throw new Error(`Missing required environment variable: ${name}`)
}

// References must be static literals so Create React App inlines them at build time.
const templateIdFor = {
  sales: () => required('REACT_APP_EMAILJS_SALES_TEMPLATE_ID', process.env.REACT_APP_EMAILJS_SALES_TEMPLATE_ID),
  talent: () => required('REACT_APP_EMAILJS_TALENT_TEMPLATE_ID', process.env.REACT_APP_EMAILJS_TALENT_TEMPLATE_ID),
}

export default function emailConfigurationFor(form) {
  const templateId = templateIdFor[form]
  if (!templateId) throw new Error(`Unknown email form: ${form}`)
  return {
    serviceId: required('REACT_APP_EMAILJS_SERVICE_ID', process.env.REACT_APP_EMAILJS_SERVICE_ID),
    templateId: templateId(),
    publicKey: required('REACT_APP_EMAILJS_PUBLIC_KEY', process.env.REACT_APP_EMAILJS_PUBLIC_KEY),
  }
}
